const NAME = "LOANS_PAGE";

export default NAME;
